var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "attr.namespace",
    title: "Namespace",
    description: "A qualified path-like identifier such as fields.myInput.value.",
    type: "attribute",
    use: {
        namespace: "ua.input"
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ namespace: "fields.myInput.value" }, "value");
            }
        },
        invalid: {
            throw: "fields.attr.namespace.invalid",
            run: function () {
                return validate({ namespace: "bad path with spaces" }, "value");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Namespace",
            description: "The namespace must be composed of valid names separated by periods.",
            template: "Invalid namespace format: '${namespace}'"
        }
    }
});

function validate(spec, value) {
    if (!spec.namespace) return;

    var segments = spec.namespace.split(".");
    for (var i = 0; i < segments.length; i++) {
        if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(segments[i])) {
            _.errors.invalid.throw({ namespace: spec.namespace });
        }
    }
}
module.exports.validate = validate;
